import { reactify } from '@zeiss/zui-react';
export const ZuiIconAnnotationsNumbers = reactify('zui-icon-annotations-numbers');
